import cTooltip from "./tooltipManager";

// needed for dashboard table / waiting for actions tooltip
const customTooltip = new cTooltip();
$(window).on('load', () => customTooltip.init());
// $(window).on('vue-update', () => customTooltip.init());
